document.addEventListener("DOMContentLoaded", (event) => {
  var crcSwiperSlider = new Swiper(
    ".s-repayment-calculator .swiper-container",
    {
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 24,
      pagination: {
        el: ".s-repayment-calculator .swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".s-repayment-calculator .swiper-next-btn",
        prevEl: ".s-repayment-calculator .swiper-prev-btn",
      },
      breakpoints: {
        1023: {
          slidesPerView: 1,
        },
        1279: {
          slidesPerView: 2,
        },
        3000: {
          slidesPerView: 3,
        },
      },
    },
  );
});

const selectors = {
  slider: ".s-repayment-calculator .swiper-container",
  pagination: ".s-repayment-calculator .swiper-pagination",
  prevBtn: ".s-repayment-calculator swiper-prev-btn",
  nextBtn: ".s-repayment-calculator swiper-next-btn",
  financeInput: "[data-finance-input]",
  financePlus: "[data-finance-plus]",
  financeMinus: "[data-finance-minus]",
  financeBlock: "[data-finance-block]",
  financeBlockTotalOrderValue: "[data-finance-block-tov]",
  financeBlockDeposit: "[data-finance-block-deposit]",
  financeBlockMonth: "[data-finance-block-month]",
  financeBlockTotal: "[data-finance-block-total]",
};

class cRepaymentCalculator {
  constructor() {
    this.elements = {
      slider: document.querySelector(selectors.slider),
      pagination: document.querySelector(selectors.pagination),
      nextBtns: Array.from(document.querySelectorAll(selectors.nextBtn)),
      prevBtns: Array.from(document.querySelectorAll(selectors.prevBtn)),
      financeInput: document.querySelector(selectors.financeInput),
      financePlus: document.querySelector(selectors.financePlus),
      financeMinus: document.querySelector(selectors.financeMinus),
      financeBlocks: Array.from(
        document.querySelectorAll(selectors.financeBlock),
      ),
    };

    // Validation
    this.validation = {
      min: this.elements.financeInput.getAttribute("data-min")
        ? Number(this.elements.financeInput.dataset.min)
        : 0,
      max: this.elements.financeInput.getAttribute("data-max")
        ? Number(this.elements.financeInput.dataset.max)
        : 0,
      step: this.elements.financeInput.getAttribute("data-step")
        ? Number(this.elements.financeInput.dataset.step)
        : 0,
      pattern: this.elements.financeInput.getAttribute("data-pattern")
        ? new RegExp(this.elements.financeInput.dataset.pattern)
        : null,
    };

    // Custom Events
    this.events = {
      totalOrderValueChanged: new Event("total-order-value-changed"),
    };
  }
  init() {
    // Init Controls
    this.initControls();

    // Update Blocks
    this.updateBlocks();
  }

  initControls() {
    // Update the input during initialisation
    this.updateInput(this.elements.financeInput.value);

    // Bind events
    this.elements.financeInput.addEventListener(
      "total-order-value-changed",
      (event) => {
        return this.updateBlocks();
      },
    );

    this.elements.financeInput.addEventListener("input", (event) => {
      return this.updateInput(this.elements.financeInput.value);
    });

    this.elements.financeInput.addEventListener("change", (event) => {
      return this.updateInput(this.elements.financeInput.value);
    });

    this.elements.financeMinus.addEventListener("click", (event) => {
      const sanitisedValue = this.sanitiseValue(
          this.elements.financeInput.value,
        ),
        updatedValue = String(
          Math.round(sanitisedValue - this.validation.step),
        );

      return this.updateInput(updatedValue);
    });

    this.elements.financePlus.addEventListener("click", (event) => {
      const sanitisedValue = this.sanitiseValue(
          this.elements.financeInput.value,
        ),
        updatedValue = String(
          Math.round(sanitisedValue + this.validation.step),
        );

      return this.updateInput(updatedValue);
    });
  }

  updateInput(value = "") {
    if (!value) return;

    const sanitisedValue = this.sanitiseValue(value),
      formattedValue = this.formatValue(sanitisedValue);

    this.elements.financeInput.value = formattedValue;
    this.elements.financeInput.dispatchEvent(
      this.events.totalOrderValueChanged,
    );
  }

  sanitiseValue(value) {
    if (!value) return;

    // Convert the value to a string
    let result = String(value);

    // Remove commas from the string
    result = result.replace(/,/g, "");

    // Convert empty string value into a 0 (still a string)
    if (result == "") result = "0";

    // Make the string obey the regex pattern
    result = result.replace(this.validation.pattern, "");

    // Parse the string into an integer
    result = parseInt(result, 10);

    // Ensure the integer is between the confines of the min/max rules
    // Set result to the min if the value is below min
    // Set result to the max if the value is above max
    if (result < this.validation.min) result = this.validation.min;
    if (result > this.validation.max) result = this.validation.max;

    // Return the result
    return result;
  }

  formatValue(value) {
    if (!value) return;

    // Convert the value to an integer
    let result = parseInt(value, 10);

    // Convert the integer into pennies
    result = parseInt(result * 100, 10);

    // Format the pennies into money using Shopify's MoneyFormat function
    result = String(this.formatMoney(result, theme.moneyFormat));

    // Remove currency symbol from the string
    const moneyFormat = String(theme.moneyFormat),
      currencySymbol = moneyFormat.substr(0, moneyFormat.indexOf("{{"));
    result = result.replace(currencySymbol, "");

    // Remove trailing zeroes from the string
    result = result.replace(".00", "");

    // Return the result
    return result;
  }

  updateBlocks() {
    this.elements.financeBlocks.forEach((financeBlock, index) => {
      const tovElement = financeBlock.querySelector(
          selectors.financeBlockTotalOrderValue,
        ),
        depositElement = financeBlock.querySelector(
          selectors.financeBlockDeposit,
        ),
        monthlyElement = financeBlock.querySelector(
          selectors.financeBlockMonth,
        ),
        totalElement = financeBlock.querySelector(selectors.financeBlockTotal),
        term = parseInt(financeBlock.dataset.financeBlockTerm, 10),
        aprPercent = parseInt(financeBlock.dataset.financeBlockAprPercent, 10),
        depositPercent = parseInt(
          financeBlock.dataset.financeBlockDepositPercent,
          10,
        ),
        inputValue = this.sanitiseValue(this.elements.financeInput.value),
        inputValueCents = parseInt(inputValue * 100, 10),
        depositAmount = Math.round((inputValueCents / 100) * depositPercent);

      tovElement.textContent = String(
        this.formatMoney(inputValueCents, theme.moneyFormat),
      ).replace(".00", "");
      depositElement.textContent = String(
        this.formatMoney(depositAmount, theme.moneyFormat),
      ).replace(".00", "");
      // monthlyElement.textContent = this.calculateFinanceMonthlyRepaymentPrice(inputValueCents, aprPercent, term);
      monthlyElement.textContent = this.calculateFinanceMonthlyRepaymentPrice(
        inputValueCents - Math.round((inputValueCents / 100) * depositPercent),
        aprPercent,
        term,
      );
      totalElement.textContent = this.calculateFinanceTotalRepaymentPrice(
        inputValueCents,
        aprPercent,
        term,
      );
    });
  }

  formatMoney(t, e) {
    "string" == typeof t && (t = t.replace(".", ""));
    var n = "",
      r = /\{\{\s*(\w+)\s*\}\}/,
      i = e || "${{amount}}";

    function o(t) {
      var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
        n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ",",
        r =
          arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".";
      if (isNaN(t) || null == t) return 0;
      var i = (t = (t / 100).toFixed(e)).split("."),
        o = i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n),
        a = i[1] ? r + i[1] : "";
      return o + a;
    }
    switch (i.match(r)[1]) {
      case "amount":
        n = o(t, 2);
        break;
      case "amount_no_decimals":
        n = o(t, 0);
        break;
      case "amount_with_comma_separator":
        n = o(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        n = o(t, 0, ".", ",");
    }
    return i.replace(r, n);
  }

  finance(t, e, n, r, i) {
    var o,
      a,
      s,
      u = e / 12 / 100;
    return (
      r
        ? 1 === r && ((o = c(n)), (a = Math.pow(1 + u, n) - 1))
        : ((o = c(12 * n)), (a = Math.pow(1 + u, 12 * n) - 1)),
      (s = t * (o / a)),
      Math.round(100 * s) / 100
    );

    function c(t) {
      return (i && (t -= 1), u * Math.pow(1 + u, t));
    }
  }

  calculateFinanceMonthlyRepaymentPrice(
    price,
    apr,
    months,
    moneyFormat = theme.moneyFormat,
  ) {
    let result = this.finance(price, apr, months, 1);
    return this.formatMoney(result, moneyFormat);
  }

  calculateFinanceTotalRepaymentPrice(
    price,
    apr,
    months,
    moneyFormat = theme.moneyFormat,
  ) {
    let result = this.finance(price, apr, months, 1) * months;
    return this.formatMoney(result, moneyFormat);
  }
}

let cRepaymentCalculatorObj = new cRepaymentCalculator();
cRepaymentCalculatorObj.init();
